import { Grid, styledComponent } from '@hermes/web-components'

export const Wrapper = styledComponent(Grid)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.white
}))

export const ContentContainer = styledComponent(Grid)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: theme.palette.common.white
}))

export const Section = styledComponent(Grid)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  borderTop: '1px solid #D5DEF9',
  padding: '40px 0'
})

export const SectionContent = styledComponent(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '1072px',
  width: '100%',
  padding: '0 32px',
  gap: '16px',
  [theme.breakpoints.down('md')]: {
    padding: '0 16px'
  }
}))
